import React from 'react';

import { Box } from '@rover/kibble/core';

type FilterSectionProps = {
  children: React.ReactNode;
  isOpen?: boolean;
  onClick?: () => void;
  id?: string;
  'aria-label'?: string;
  'aria-controls'?: string;
};

const FilterSection = React.forwardRef<HTMLElement, FilterSectionProps>(
  (
    { children, isOpen, onClick, id, 'aria-label': ariaLabel, 'aria-controls': ariaControls },
    ref
  ): JSX.Element => {
    return (
      <Box
        ref={ref}
        webAs="button"
        id={id}
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        px="4x"
        onPress={onClick}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        aria-controls={ariaControls}
        aria-label={ariaLabel}
        sx={(theme) => ({
          cursor: 'pointer',
          border: '3px solid transparent',
          backgroundColor: 'transparent',
          borderRadius: 0,
          ...(isOpen && {
            borderColor: theme.colors.border.input_focus,
            borderRadius: theme.radii.secondary,
          }),
        })}
      >
        {children}
      </Box>
    );
  }
);

FilterSection.displayName = 'FilterSection';

export default FilterSection;
